// extracted by mini-css-extract-plugin
export var gif = "_kj-0";